import { Slide, SlideProps } from '@mui/material';
import React from 'react';

export const FullScreenDialogTransition = React.forwardRef<unknown, SlideProps>(
  (props: SlideProps, ref: React.Ref<unknown>) => (
    <Slide direction="up" timeout={1000} ref={ref} {...props} />
  )
);
